// src/router/guard/analytics-guard.ts
// Router guard for automatic page tracking with Sentry and GA4 analytics
// Tracks page views, navigation patterns, and page engagement
// RELEVANT FILES: src/router/guard/index.ts, src/utils/sentry-analytics.ts, src/utils/ga4.ts

import type { Router } from 'vue-router';
import { trackGAEvent } from '@/utils/ga4';
import { trackPageVisit } from '@/utils/sentry-analytics';

/**
 * Setup analytics tracking guard
 * Automatically tracks page views and navigation patterns
 */
export function analyticsGuard(router: Router): void {
  // Track page views after navigation completes
  router.afterEach((to, from) => {
    // Track page visit in Sentry session analytics
    trackPageVisit(to.path, to.meta?.title as string | undefined);

    // Track page view in GA4 (required for SPA routing)
    trackGAEvent('page_view', {
      page_title: (to.meta?.title as string) || to.name || to.path,
      page_location: window.location.href,
      page_path: to.path,
      page_referrer: from.path || '',
    });
  });
}
